// Personal penalties (002 FR-012/013, parity with web baseline 001).
//
// Up to three per team. They run IN PARALLEL — each penalty is an independent clock
// (see clock.js) — and are cleared INDEPENDENTLY when they reach zero. Penalties are
// NOT queued; queuing applies only to the derived team inferiority (see inferiority.js).
//
// A penalty extends the clock shape: { id, playerNumber, durationMs, startedAt }.

import { remainingMs, startClock, stopClock } from './clock.js';

export const MAX_PENALTIES_PER_TEAM = 3;

export function createPenalty(id, durationMs, playerNumber = null) {
  return { id, playerNumber, durationMs: Math.max(0, durationMs), startedAt: null };
}

/** Can another penalty be added to this team? */
export function canAdd(penalties) {
  return penalties.length < MAX_PENALTIES_PER_TEAM;
}

/** Start all active penalties at `now` (parallel). */
export function startAll(penalties, now) {
  return penalties.map((p) => startClock(p, now));
}

/** Pause all active penalties at `now`, preserving each remaining time. */
export function pauseAll(penalties, now) {
  return penalties.map((p) => stopClock(p, now));
}

/** Drop penalties that have reached zero — independent, parallel clearing. */
export function clearExpired(penalties, now) {
  return penalties.filter((p) => remainingMs(p, now) > 0);
}

/** Remaining time (ms) of a specific penalty. */
export function penaltyRemainingMs(penalty, now) {
  return remainingMs(penalty, now);
}
